import { Pipe, PipeTransform } from "@angular/core";
import moment from 'moment';
import * as _ from 'underscore';


/**
 * Formatte le nombre pour qu'il ait x chiffres après la virgule
 * @param number le nombre de chiffres après la virgule
 * @example | toFixed:2
 */
@Pipe({
  name: "toFixed"
})
export class SuperPipeToFixedFormat implements PipeTransform {
    transform(value: any, number:number) {
        if(_.isNumber(value)) return Number(value).toFixed(number)
        else return ""
    }
}


/**
 * Formatte l'array pour qu'il renvoit un array modifié en mode label/value ( utile pour Primeng )
 * @param labelKey la chaine de caractères
 * @param valueKey le nombre maximum de caractères
 * @example | toLV:"label":"value"
 */
@Pipe({
  name: "toLV"
})
export class SuperPipeToLVFormat implements PipeTransform {
    transform(array: Array<any>, labelKey:string = "label", valueKey:string = "id") {
      return array.map( x => {
        return {
          label : x[labelKey], 
          value : x[valueKey]
        }
      })
    }
}

/**
 * Formatte la date à l'aide de la librairie moment.js
 * @example | momentFormat:"DD/MM/YYYY"
 */
@Pipe({
    name: 'momentFormat',
})
export class SuperPipeMomentFormat implements PipeTransform {
    transform(value: string|Date|moment.Moment, field:string) {
      if(value){
        return  moment(value).format(field);
      } else {
        return '';
      }
    }
}

/**
 * Formatte la valeur en bytes (kB, MB, GB, ...)
 * @example | sizeFormat
 */
@Pipe({
    name: 'sizeFormat',
})
export class SuperPipeSizeFormat implements PipeTransform {
    transform(fileSizeInBytes: number) {
      var i = -1;
      var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
      do {
          fileSizeInBytes = fileSizeInBytes / 1024;
          i++;
      } while (fileSizeInBytes > 1024);

      return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
    };
}

/**
 * Formatte la chaine de caractères pour qu'elle ne dépasse pas un certain nombre de caractères (suivi de ...) 
 * @param number le nombre maximum de caractères
 * @example | maxLength:25
 */
@Pipe({
    name: 'maxLength',
})
export class SuperPipeLengthFormat implements PipeTransform {
    transform(value: string, number:number = 25) {
      if(value && value.length>number) return value.substr(0,number)+'...'
      else return value
    };
}

/**
 * Formatte la chaine de caractères pour mettre une majuscule au premier caractère 
 * @example | ucFirst
 */
@Pipe({
  name: 'ucFirst'
})
export class SuperPipeUcFirst implements PipeTransform {
  transform(string:string) {
    return string && string.length>0 ? String(string).charAt(0).toUpperCase() + String(string).slice(1).toLowerCase() : "";
  }
}

/**
 * On récupère les clés string[] de l'objet 
 * @example | getKeys
 */
@Pipe({
  name: 'getKeys'
})
export class SuperPipeGetKeys implements PipeTransform {
  transform(value:any) {
    let keys = [];
    for (let key in value) {
      keys.push(key);
    }
    return keys;
  }
}